export default {
  esgHeroTitle1: "转变健康，",
  esgHeroTitle2: "赋能可持续发展",
  esgHeroDescription: "Refex Life Sciences代表我们共同构建更健康、更清洁、更可持续世界的愿景。以创新和责任为锚，我们寻求通过负担得起的技术、道德实践和环境管理重新定义医疗保健。",
  esgHeroSubDescription: "我们渴望弥合现代科学与可持续生活之间的差距——创造惠及个人、社区和地球的价值。",
  esgVisionMissionTitle: "愿景与使命",
  esgVisionMissionSubtitle: "我们对可持续医疗保健和环境管理的承诺",
  esgVisionTitle: "我们的愿景",
  esgVisionSubtitle: "可持续医疗保健合作伙伴",
  esgVisionDescription: "成为值得信赖的可持续医疗保健合作伙伴，提供有影响力的生命科学解决方案，改善生活，同时为子孙后代保护环境。",
  esgMissionTitle: "我们的使命",
  esgMissionSubtitle: "有影响力的解决方案",
  esgMissionPoint1: "提供创新、负担得起和高质量的医疗保健解决方案",
  esgMissionPoint2: "将可持续性和道德融入每个决策的核心",
  esgMissionPoint3: "通过可及的医疗保健和教育赋能社区",
  esgMissionPoint4: "为印度的可持续发展和气候目标做出贡献",
  esgHeartTitle: "可持续发展——我们进步的核心",
  esgHeartSubtitle: "Refex Life Sciences在Refex集团的ESG战略和可持续发展路线图下运营。我们的综合方法确保在所有维度上实现负责任的增长。",
  esgHeartEnvironmentalTitle: "环境责任",
  esgHeartEnvironmentalDescription: "通过创新的绿色技术和可持续实践减少碳排放、能源使用和浪费。",
  esgHeartSocialTitle: "社会公平",
  esgHeartSocialDescription: "通过包容性增长倡议促进医疗保健可及性、教育和社区赋权。",
  esgHeartGovernanceTitle: "治理卓越",
  esgHeartGovernanceDescription: "通过强大的治理框架在所有运营中维护诚信、透明度和问责制。",
  esgHeartCommitmentsTitle: "我们的可持续发展承诺",
  esgHeartCommitmentsSubtitle: "推动我们向可持续未来转型的可衡量目标",
  esgHeartMetricNetZero: "净零",
  esgHeartMetricCarbon2040: "2040年碳中和",
  esgHeartMetricGreenTech: "绿色科技",
  esgHeartMetricInnovation: "创新重点",
  esgHeartMetricHealthcare: "医疗保健",
  esgHeartMetricAccessAll: "全民可及",
  esgHeartMetricEducation: "教育",
  esgHeartMetricCommunityGrowth: "社区增长",
  esgHeartMetricZeroHarm: "零伤害",
  esgHeartMetricAllOperations: "所有运营",
  esgHeartMetric100Percent: "100%",
  esgHeartMetricTransparency: "透明度",
  esgHeartCommitmentNetZero: "净零",
  esgHeartCommitmentCarbon2040: "2040年碳中和排放",
  esgHeartCommitmentWaterPositive: "水资源积极",
  esgHeartCommitmentWaterPositiveSub: "2030年运营",
  esgHeartCommitmentZeroWaste: "零浪费",
  esgHeartCommitmentZeroWasteSub: "2025年零填埋",
  esgHeartCommitmentRenewableEnergy: "100%可再生能源",
  esgHeartCommitmentRenewableEnergySub: "2035年能源",
  esgSdgTitle: "与联合国可持续发展目标保持一致",
  esgSdgSubtitle: "我们将努力与反映我们使命和行动的关键可持续发展目标保持一致，为全球可持续发展做出有意义的贡献。",
  esgSdgContribution: "我们的贡献",
  esgSdg3Title: "良好健康与福祉",
  esgSdg3Contribution: "通过我们全面的制药解决方案和在80多个国家的全球影响力，促进负担得起、可及的医疗保健和预防医学。",
  esgSdg6Title: "清洁饮水和卫生设施",
  esgSdg6Contribution: "支持集团的水资源恢复和水资源积极性项目，在我们所有制造设施中实施可持续的水资源管理实践。",
  esgSdg7Title: "经济适用的清洁能源",
  esgSdg7Contribution: "承诺运营向可再生能源转型，在我们全球制造设施中实施太阳能和风能解决方案。",
  esgSdg9Title: "产业、创新和基础设施",
  esgSdg9Contribution: "鼓励可持续生命科学和绿色制造的研发，投资尖端技术和创新中心。",
  esgSdg12Title: "负责任的消费和生产",
  esgSdg12Contribution: "通过绿色化学原理和可持续制造工艺，强调减少浪费、材料的循环使用和高效的资源利用。",
  esgSdg13Title: "气候行动",
  esgSdg13Contribution: "通过绿色基础设施、采用可再生能源和减少碳足迹的倡议，支持集团的2040年净零碳使命。",
  esgSdg17Title: "促进目标实现的伙伴关系",
  esgSdg17Contribution: "与研究机构、非政府组织和全球可持续医疗保健倡议合作，促进推动创新和在整个制药行业产生积极影响的伙伴关系。",
  esgInnovationTitle: "创新与数字化转型",
  esgInnovationDescription: "利用尖端技术和数字解决方案转变制药运营，提高效率，并在整个价值链中推动可持续创新。",
  esgDigitalSolutionsTab: "数字解决方案",
  esgResearchInnovationTab: "研究与创新",
  esgDigitalSolutionsTitle: "数字解决方案",
  esgDigitalSolutionsSubtitle: "数据驱动的卓越",
  esgResearchInnovationTitle: "研究与创新",
  esgResearchInnovationSubtitle: "有目的的创新",
  esgDigitalCard1Title: "数字制造",
  esgDigitalCard1Description: "先进的自动化和数据分析，用于优化生产流程和质量控制。",
  esgDigitalCard2Title: "供应链智能",
  esgDigitalCard2Description: "实时跟踪和预测分析，确保无缝运营和及时交付。",
  esgDigitalCard3Title: "质量管理系统",
  esgDigitalCard3Description: "集成数字平台，用于所有运营的监管合规和质量保证。",
  esgResearchCard1Title: "API开发",
  esgResearchCard1Description: "复杂活性药物成分的先进工艺开发和优化。",
  esgResearchCard2Title: "制剂研究",
  esgResearchCard2Description: "开发复杂仿制药和特殊制剂的创新方法。",
  esgResearchCard3Title: "绿色化学",
  esgResearchCard3Description: "可持续的合成方法和环保的制造工艺。",
  esgSocialTitle: "社会责任与社区参与",
  esgSocialDescription: "我们的承诺超越商业，致力于促进积极的社会影响。我们积极参与社区发展、医疗可及性和教育倡议，确保我们的增长有助于建设一个更加公平和健康的社会。",
  esgCsrCard1Title: "儿童教育",
  esgCsrCard1Subtitle: "与技能发展",
  esgCsrCard1Description: "支持教育倡议和技能发展计划，为儿童和青年提供知识和机会，创造更光明的未来。",
  esgCsrCard1Highlight: "培养未来的领导者",
  esgCsrCard2Title: "健康意识",
  esgCsrCard2Subtitle: "与预防保健",
  esgCsrCard2Description: "推广健康意识活动和预防保健计划，改善社区健康结果，减少医疗保健差距。",
  esgCsrCard2Highlight: "更健康的社区",
  esgCsrCard3Title: "环境",
  esgCsrCard3Subtitle: "保护",
  esgCsrCard3Description: "领导水体恢复和植树造林倡议，恢复生态系统，应对气候变化，创造可持续的未来。",
  esgCsrCard3Highlight: "保护我们的星球",
  esgCsrImpact1Title: "教育",
  esgCsrImpact1Description: "支持学校和技能发展中心",
  esgCsrImpact2Title: "医疗保健",
  esgCsrImpact2Description: "移动健康诊所和意识计划",
  esgCsrImpact3Title: "环境",
  esgCsrImpact3Description: "植树造林和水资源保护项目",
  esgSocialImpactTitle: "通过伙伴关系产生社区影响",
  esgSocialImpactDescription: "通过战略合作和专门计划，我们赋能当地社区，改善医疗基础设施，支持教育机会，创造持久的积极变化。",
  esgFooterTitle: "迈向可持续的明天",
  esgFooterCta: "为子孙后代提供\"有目标的健康\"",
};

